import LongAngleLogo from '../assets/long-angle.png'
import LongAngleLogoMobile from '../assets/long-angle-mobile.png'
import MlgLogo from '../assets/mlg.png'
import MlgLogoMobile from '../assets/mlg-mobile.gif'
import AspenLogo from '../assets/aspen.png'
import AspenLogoMobile from '../assets/aspen-mobile.png'
import NhLogo from '../assets/nh.png'
import MagCapitalLogo from '../assets/mag.png'
// import MagCapitalLogoMobile from '../assets/mag-mobile.png'
import NewVestLogo from '../assets/new-vest.png'
import NewVestLogoMobile from '../assets/new-vest-mobile.png'



const dealFlowsItems = [
  {
    id: 1,
    institution: 'KKR Evergreen',
    fundName: 'Private Equity Fund',
    nameForEvents: 'KKR',
    logo: LongAngleLogo,
    mobileLogo: LongAngleLogoMobile,
    mobileLogoWidth: '124px',
    closedAt: new Date('2024-12-19'),
    //webinarAt: new Date('2025-01-09T19:00:00'),
    stats: [
      {
        title: 'Minimum Commitment',
        value: <>$50<span style={{fontSize:'28px'}}>K</span></>,
      },
      {
        title: 'Target net IRR',
        value: '11-15%',
      },
    ],
    details: [
      '48-year track record with no principal losses across 25 funds, 22 beating S&P 500',
      'Quarterly redemptions available after 2-year soft lock',
      '0.25% fee discount for commitments made by December 19th, 2024',
      '15%+ CoC returns in Upstream Energy Fund VI',
    ],
  },
  {
    id: 2,
    institution: 'MLG Capital',
    fundName: 'Private Real Estate Fund VI',
    nameForEvents: 'MLG',
    logo: MlgLogo,
    mobileLogo: MlgLogoMobile,
    mobileLogoWidth: '124px',
    closedAt: new Date('2024-12-31'),
    // webinarAt: new Date('2025-01-09T19:00:00'),
    stats: [
      {
        title: 'Target fund size',
        value: <>$400<span style={{fontSize:'28px'}}>M</span></>,
      },
      {
        title: 'Target net IRR',
        value: '11-15%',
      },
      {
        title: 'Preferred Return',
        value: '8%',
      },
      {
        title: 'Target quarterly distributions',
        value: '3-5%',
      },
    ],
    details: [
      '100% success in quarterly distributions',
      'Top 5% in achieving target returns',
      '42% of investors reinvest'
    ],
    downloadDeckUrl: 'https://drive.google.com/file/d/1_km2LPyLsuC4oy4Odi7TzPxVMwIKZADQ/view?usp=sharingg',
    // joinSpvUrl: 'https://app.verivend.com/deal/view/2794e4fc-3e9e-405b-bc00-e8e6d798e885',
    watchWebinarUrl: 'https://www.youtube.com/watch?v=8F1IeM2PaJ4',
    // joinWebinarUrl: 'https://us06web.zoom.us/webinar/register/WN_tQSm5a7eSCGPc4ZI2CrWSQ',
  },
  {
    id: 3,
    institution: 'Mag Capital',
    fundName: 'MAGCP Industrial Fund III',
    nameForEvents: 'MAG',
    logo: MagCapitalLogo,
    closedAt: new Date('2025-01-15'),
    stats: [
      {
        title: 'Target fund size',
        value: <>$250<span style={{fontSize:'28px'}}>M</span></>,
      },
      {
        title: 'Target net IRR',
        value: '14-16%',
      },
      {
        title: 'Annual cash yield',
        value: '6-8%',
      },
      {
        title: 'Target MOIC',
        value: '1.95x',
      },
    ],
    details: [
      '52 Active Vyzer Investors',
      '57% Repeat Investors',
      '7.03% Average ongoing Distributions',
      '100% Target Performance Met'
    ],
    downloadDeckUrl: 'https://drive.google.com/file/d/1ea2ca6LK4cR-Oig5PdIFpCn-WcCpjJMr/view?usp=sharing',
    watchWebinarUrl: 'https://www.youtube.com/watch?v=5QxjDRz2SEc',
  },
  {
    id: 4,
    institution: 'New Vest',
    fundName: 'PE50 2024 Private Equity Index Fund',
    nameForEvents: 'NewVest',
    logo: NewVestLogo,
    mobileLogo: NewVestLogoMobile,
    mobileLogoWidth: '124px',
    closedAt: new Date('2024-02-28'),
    // webinarAt: new Date('2025-01-09T19:00:00'),
    stats: [
      {
        title: 'Minimum Commitment',
        value: <>$100<span style={{fontSize:'28px'}}>K</span></>,
      },
      {
        title: 'Net IRR (Historical pooled returns)',
        value: '13-17%',
      },
    ],
    details: [
      'Access to 50 premier PE funds through a single investment',
      'Institutional-grade diversification across strategies, sectors, and regions',
      '$100K minimum vs. typical $10M direct investment minimum',
      'Index-style investing approach adapted for private equity'
    ],
    customContentBottom: <div style={{paddingRight:'24px' , marginTop:'16px'}}>
    Note: Investment available to <b>U.S. Qualified Purchasers</b> and <b>international investors</b> meeting their local accredited investor requirements.
    </div>,
     downloadDeckUrl: 'https://drive.google.com/file/d/1HQcZrpVyPdSVdIgm4RpQyjB_t_5Cy013/view?usp=sharing',
    // joinSpvUrl: 'https://app.verivend.com/deal/view/2794e4fc-3e9e-405b-bc00-e8e6d798e885',
    watchWebinarUrl: 'https://www.youtube.com/watch?v=imoLHh07IlA',
    // joinWebinarUrl: 'https://us06web.zoom.us/webinar/register/WN_tQSm5a7eSCGPc4ZI2CrWSQ',
  },
  {
    id: 5,
    institution: 'Aspen Funds',
    fundName: '51 Upstream Energy Fund VII',
    nameForEvents: 'Aspen',
    logo: AspenLogo,
    mobileLogo: AspenLogoMobile,
    mobileLogoWidth: '124px',
    closedAt: new Date('2025-04-10'),
    webinarAt: new Date('2025-01-09T19:00:00'),
    stats: [
      {
        title: 'Target fund size',
        value: <>$75<span style={{fontSize:'28px'}}>M</span></>,
      },
      {
        title: 'IRR (Projected returns)',
        value: '25-35%',
      },
      {
        title: 'Equity multiple',
        value: '4-7x',
      },
      {
        title: 'Waterfall structure',
        value: '70/30',
      },
    ],
    details: [
      '45% investors come back for more',
      '100% on-time distributions',
      'Top 5% in investor communications',
      '15%+ CoC returns in Upstream Energy Fund VI',
    ],
    downloadDeckUrl: 'https://drive.google.com/file/d/1O4mrtV25oUSf5Szkp3JVgMoZBGZnlaKe/view?usp=sharing',
    joinSpvUrl: 'https://app.verivend.com/deal/view/2794e4fc-3e9e-405b-bc00-e8e6d798e885',
    watchWebinarUrl: 'https://youtu.be/rRBEzJEh7Kg',
    joinWebinarUrl: 'https://us06web.zoom.us/webinar/register/WN_tQSm5a7eSCGPc4ZI2CrWSQ',
  },
  {
    id: 6,
    institution: 'New Haven Marinas',
    fundName: 'NH Marinas Fund II',
    nameForEvents: 'NH',
    logo: NhLogo,
    closedAt: new Date('2025-04-15'),
    // webinarAt: new Date('2025-02-09T19:00:00'),
    stats: [
      {
        title: 'Minimum commitment',
        value: <>$50<span style={{fontSize:'28px'}}>K</span></>,
      },
      {
        title: 'Target IRR',
        value: '30%+',
      },
      {
        title: 'Preferred return',
        value: '8-10%',
      },
      {
        title: 'Target exit cap rate',
        value: '6-8%',
      },
    ],
    details: [
      '30%+ NOI Growth via value-add strategies',
      '9 Revenue Streams beyond slip rentals',
      '70%+ of marinas are 95-100% occupied year-round with 4-6% rent increases',
      '5-Year Exit Strategy, with refinance in Year 4 to return investor capital',
    ],
    downloadDeckUrl: 'https://drive.google.com/file/d/1nR1Ogdx3fBPZ_VQXtky20CihkqToeq0s/view',
    joinSpvUrl: 'https://app.verivend.com/deal/view/d2e86d8d-56a3-42c5-b309-b4c5e10dc54e',
    watchWebinarUrl: 'https://youtu.be/UaeGtzr0-8A',
    joinWebinarUrl: 'https://us06web.zoom.us/webinar/register/9717427233871/WN_9nKrfSWeRpq-9BmsxHKc1Q',
  },
]

export const sortedDealFlowsItems = [...dealFlowsItems].reverse();

